export const reports = {
  INDEX: '/reports',
  BALANCE: '/reports/balance',
}
